module.exports = __webpack_public_path__ + "static/media/male_selected.3084b70c.png";